import React, { Component } from 'react'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import { phone as phonePattern } from './../../shared/patterns/telephone.pattern'
import ReCAPTCHA from 'react-google-recaptcha'
import './Quote.scss'
import NumberFormat from 'react-number-format'

class Quote extends Component {
  recaptchaRef = this.props.useCaptcha ? React.createRef() : null
  formError = false

  constructor(props) {
    super(props)

    this.regPhone = new RegExp(phonePattern)
    this.regEmail = new RegExp(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,6}$/
    )

    this.state = {
      protection_level: 150,
      firstname: '',
      lastname: '',
      email: '',
      mobile: '',
      tobacco_user: '',
      how_help: '',
      how_hear: '',
      how_hear_detail: '',
      customer_type: '',
      contact_preference: '',
      zipcode: '',
      age: '',
      formError: false,
      errorMessage: '',
      quoteSubmit: false,
    }
    this.onChange = this.onChange.bind(this)
    this.CREATEQuote_API = this.CREATEQuote_API.bind(this)
  }

  async validate() {
    const {
      firstname,
      lastname,
      email,
      mobile,
      captcha,
      how_hear,
      how_hear_detail,
    } = this.state

    if (!(firstname && firstname.trim())) return false
    if (!(lastname && lastname.trim())) return false

    if (!this.regEmail.test(email)) {
      this.setState({
        formError: true,
        errorMessage: 'E-mail address is not valid',
      })
      return false
    }

    if (!(mobile && mobile.trim())) return false

    if (!this.regPhone.test(mobile)) {
      this.setState({
        formError: true,
        errorMessage: 'Phone number is not valid',
      })
      return false
    }

    // if (!(zipcode && zipcode.trim())) return false

    if (!!this.recaptchaRef && !captcha) return false

    if (how_hear === 'other' && !how_hear_detail) return false

    this.setState({ formError: false, errorMessage: '' })
    return true
  }

  async CREATEQuote_API(event) {
    let targetDom = event.target
    event.persist()
    event.preventDefault()
    if (!event.target.className.includes(' was-validated'))
      event.target.className += ' was-validated'
    const isValid = await this.validate()

    const {
      protection_level,
      firstname,
      lastname,
      email,
      mobile,
      tobacco_user,
      how_help,
      how_hear,
      how_hear_detail,
      customer_type,
      contact_preference,
      zipcode,
      age,
      formError,
      errorMessage,
      quoteSubmit,
    } = this.state

    if (quoteSubmit) return false

    if (formError) {
      // event.preventDefault()
      toast.error(errorMessage, { position: toast.POSITION.TOP_RIGHT })
      return false
    }

    if (!isValid) {
      toast.error('Invalid form data', { position: toast.POSITION.TOP_RIGHT })
      return
    }

    const data = {
      protection_level,
      firstname,
      lastname,
      email,
      mobile,
      tobacco_user,
      how_help,
      how_hear,
      how_hear_detail,
      customer_type,
      contact_preference,
      zipcode,
      age,
      req_url: window.location.href,
      ref_url: document.referrer,
      insurance_type: this.props.insuranceType,
    }

    let form_data = new FormData()

    for (let key in data) form_data.append(key, data[key])

    try {
      await AdminApi.createQuoteRequest(form_data).then((response) => {
        this.setState({ quoteSubmit: false })
        if (typeof this.props?.onSuccess === 'function')
          this.props.onSuccess({ response })
        if (response.status === 200) {
          this.setState({
            protection_level: 150,
            firstname: '',
            lastname: '',
            email: '',
            mobile: '',
            tobacco_user: '',
            how_help: '',
            how_hear: '',
            how_hear_detail: '',
            customer_type: '',
            contact_preference: '',
            zipcode: '',
            age: '',
            formError: false,
            errorMessage: '',
          })

          if (this.recaptchaRef) window.grecaptcha.reset()

          toast.success('Quote request sent!', {
            position: toast.POSITION.TOP_RIGHT,
          })

          targetDom.className = targetDom.className.replace(
            / was-validated/g,
            ''
          )
        }
      })
    } catch (error) {
      if (typeof this.props?.onFailure === 'function')
        this.props.onFailure({ error })
      this.setState({ quoteSubmit: false })
      targetDom.className = targetDom.className.replace(/ was-validated/g, '')
      toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
    }

    return false
  }

  onChange(event) {
    if (event.target.name === 'firstname' || event.target.name === 'lastname') {
      if (event.target.value && !/^[a-zA-Z\- ]+$/.test(event.target.value)) {
        return
      }
    }
    if (event.target.name === 'email') {
      if (
        event.target.value &&
        !/^(([A-Za-z0-9._%+-]*)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]*)|([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{0,6}))$/.test(
          event.target.value
        )
      ) {
        return
      }
    }
    if (event.target.name === 'zipcode') {
      if (
        event.target.value &&
        !/^(\d{1,5}|\d{5}(\-\d{1,4}|\-)?)$/.test(event.target.value)
      ) {
        return
      }
    }
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  render() {
    toast.configure()

    const {
      firstname,
      lastname,
      email,
      mobile,
      tobacco_user,
      age,
      how_help,
      how_hear,
      how_hear_detail,
      customer_type,
      contact_preference,
      zipcode,
      quoteSubmit,
    } = this.state
    return (
      <div
        id="small-business-form-wrapper"
        className="QuoteFormComponent container-fluid"
      >
        <div className="row">
          <div className="col">
            <form
              data-form-output="form-output-global"
              data-form-type="contact"
              onSubmit={(event) => this.CREATEQuote_API(event)}
              noValidate
              className="range range-xs-center range-sm-left rd-mailform"
            >
              <div className="cell-sm-12 mb-1">
                <h6 className="text-spacing-0 font-default">
                  Personal information:
                </h6>
              </div>
              <div className="cell-sm-6">
                <div className="form-group form-group-outside">
                  <select
                    id="tobacco_user"
                    data-minimum-results-for-search="Infinity"
                    name="tobacco_user"
                    value={tobacco_user}
                    onChange={this.onChange}
                    className="form-control select-filter mb-2"
                  >
                    <option>Do you smoke?</option>
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </select>
                  <label
                    htmlFor="tobacco_user"
                    className="form-label form-label-outside veil"
                  >
                    Do you smoke?
                  </label>
                </div>
              </div>
              <div className="cell-sm-6 offset-top-20 offset-sm-top-0">
                <div className="form-group form-group-outside">
                  <select
                    id="age"
                    data-minimum-results-for-search="Infinity"
                    name="age"
                    value={age}
                    onChange={this.onChange}
                    className="form-control select-filter mb-2"
                  >
                    <option value="">Your age</option>
                    <option value="18 - 20">18 - 20</option>
                    <option value="21 - 25">21 - 25</option>
                    <option value="26 - 36">26 - 36</option>
                    <option value="37 - 48">37 - 48</option>
                    <option value="49 - 55">49 - 55</option>
                    <option value="56 <">Over 55</option>
                  </select>
                  <label
                    htmlFor="age"
                    className="form-label form-label-outside veil"
                  >
                    Your age
                  </label>
                </div>
              </div>
              <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                <div className="form-group form-group-outside">
                  <select
                    id="how_help"
                    data-minimum-results-for-search="Infinity"
                    name="how_help"
                    value={how_help}
                    onChange={this.onChange}
                    className="form-control select-filter mb-2"
                  >
                    <option>How can we help you?</option>
                    <option value="dontlikeit">
                      I have health insurance but don’t like it
                    </option>
                    <option value="needit">
                      {' '}
                      I don’t have any health insurance and need it
                    </option>
                    <option value="agent">
                      I’m an agent interested in a career, Budget
                    </option>
                  </select>
                  <label
                    htmlFor="how_help"
                    className="form-label form-label-outside veil"
                  >
                    How can we help you?
                  </label>
                </div>
              </div>
              <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                <div className="form-group form-group-outside">
                  <select
                    id="customer_type"
                    data-minimum-results-for-search="Infinity"
                    name="customer_type"
                    value={customer_type}
                    onChange={this.onChange}
                    className="form-control select-filter mb-2"
                  >
                    <option>Customer Type</option>
                    <option value="individual">Individual</option>
                    <option value="business">Business</option>
                  </select>
                  <label
                    htmlFor="customer_type"
                    className="form-label form-label-outside veil"
                  >
                    Customer Type
                  </label>
                </div>
              </div>
              <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                <div className="form-group form-group-outside">
                  <select
                    id="contact_preference"
                    data-minimum-results-for-search="Infinity"
                    name="contact_preference"
                    value={contact_preference}
                    required
                    onChange={this.onChange}
                    className="form-control select-filter mb-2"
                  >
                    <option>Contact Preference</option>
                    <option value="Phone Call">Phone Call</option>
                    <option value="Text">Text</option>
                    <option value="Email">Email</option>
                  </select>
                  <div className="invalid-feedback">
                    Please provide contact preference.
                  </div>
                </div>
              </div>
              <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                <div className="form-group form-group-outside">
                  <select
                    id="how_hear"
                    data-minimum-results-for-search="Infinity"
                    name="how_hear"
                    value={how_hear}
                    onChange={this.onChange}
                    className="form-control select-filter mb-2"
                  >
                    <option value="">How did you hear about us?</option>
                    <option value="search_engine">Search Engine</option>
                    <option value="referral">Referral</option>
                    <option value="radio_ad">Radio Ad</option>
                    <option value="other">Other</option>
                  </select>
                  <label
                    htmlFor="how_hear"
                    className="form-label form-label-outside veil"
                  >
                    How did you hear about us?
                  </label>
                </div>
              </div>
              {how_hear === 'other' && (
                <>
                  <div className="cell-sm-6 offset-top-20 offset-sm-top-30"></div>
                  <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                    <div className="form-group form-group-outside">
                      <input
                        id="how_hear_detail"
                        type="text"
                        name="how_hear_detail"
                        data-constraints="@Required"
                        className="form-control bg-whisper-lighten border-radius-0 mb-2"
                        value={how_hear_detail}
                        onChange={this.onChange}
                        pattern="^[a-zA-Z\- ]+$"
                        placeholder={'Please tell us how you heard'}
                        required
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="range offset-top-40">
                <div className="cell-sm-12">
                  <h6 className="text-spacing-0 font-default">
                    Contact details:
                  </h6>
                </div>
                <div className="cell-sm-6 offset-top-20">
                  <div className="form-group form-group-outside">
                    <input
                      id="contact-name"
                      type="text"
                      name="firstname"
                      data-constraints="@Required"
                      className="form-control bg-whisper-lighten border-radius-0 mb-2"
                      value={firstname}
                      onChange={this.onChange}
                      pattern="^[a-zA-Z\- ]+$"
                      placeholder={'First name'}
                      required
                    />
                    <div className="invalid-feedback">
                      Please provide valid first name.
                    </div>
                  </div>
                </div>
                <div className="cell-sm-6 offset-top-20">
                  <div className="form-group form-group-outside">
                    <input
                      id="contact-name-1"
                      type="text"
                      name="lastname"
                      data-constraints="@Required"
                      className="form-control bg-whisper-lighten border-radius-0 mb-2"
                      pattern="^[a-zA-Z\- ]+$"
                      value={lastname}
                      onChange={this.onChange}
                      placeholder={'Last name'}
                      required
                    />
                    <div className="invalid-feedback">
                      Please provide valid last name.
                    </div>
                  </div>
                </div>
                <div className="cell-sm-6 offset-top-20">
                  <div className="form-group form-group-outside">
                    <NumberFormat
                      id="contact-phone"
                      value={mobile}
                      name={'mobile'}
                      disabled={false}
                      className="form-control bg-whisper-lighten border-radius-0 mb-2"
                      format={'1 (###) ### ####'}
                      placeholder="Phone"
                      mask={'_'}
                      required
                      isAllowed={(v) => {
                        return parseInt(v.value[0]) > 1
                      }}
                      onChange={this.onChange}
                    />
                    <div className="invalid-feedback">
                      Please complete or correct the phone number.
                    </div>
                  </div>
                </div>
                <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                  <div className="form-group form-group-outside">
                    <input
                      id="contact-email"
                      type="email"
                      name="email"
                      data-constraints="@Required"
                      className="form-control bg-whisper-lighten border-radius-0 mb-2"
                      value={email}
                      autoComplete="off"
                      onChange={this.onChange}
                      placeholder={'E-mail'}
                      required
                    />
                    <div className="invalid-feedback">
                      Please complete or correct the email address.
                    </div>
                  </div>
                </div>
                {/* <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                  <div className="form-group form-group-outside">
                    <input
                      id="zip"
                      type="text"
                      name="zipcode"
                      className="form-control bg-whisper-lighten border-radius-0 mb-2"
                      placeholder={'Zip'}
                      value={zipcode}
                      data-constraints="@Required"
                      required
                      onChange={this.onChange}
                    />
                  </div>
                </div> */}
                <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                  <div
                    style={{
                      textAlign: 'center',
                      padding: '2px',
                      color: '#666',
                    }}
                  >
                    <small>
                      Not available in all states, including New York.
                    </small>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-icon btn-icon-right btn-primary-contrast btn-custom btn-block"
                    style={{ marginTop: '15px' }}
                  >
                    <span>{quoteSubmit ? 'Submitting...' : 'Get a Quote'}</span>
                    <span className="icon icon-xs-smaller fa-angle-right"></span>
                  </button>
                </div>
                <div className="cell-sm-6 offset-top-20 offset-sm-top-30">
                  {this.recaptchaRef ? (
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      sitekey="6Lc_aeIZAAAAACSfGY2OqRXdIzJ1jPOIW__6gq11"
                      onChange={(event) => {
                        this.onCaptchaChange()
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="cell-sm-12 mt-3">
                  <p className="text-spacing-0 font-default">
                    By submitting my contact information, I verify that the
                    contact information entered is correct and is my personal
                    information and that I am over 18 years of age.
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default Quote
